// extracted by mini-css-extract-plugin
export default {"wrapper":"live-status-module--wrapper--f1b13","footer":"live-status-module--footer--0251c"};